import { AdminApiClient } from '@guiker/propsharing-shared'
import { useAuthenticatedApiClient } from '@guiker/react-framework'

export const useAdminApiClient = useAuthenticatedApiClient(AdminApiClient)
